import * as React from "react";
import Modal from "react-bootstrap/Modal";
import {
  container,
  modalContainer,
  modalHeader,
  modalBody,
} from "./SuccessModal.module.scss";
import { ISuccessModalProps } from "./SuccessModalProps";

export const Container: React.FC<any> = (props) => {
  return (
    <div className={container} id={props.id}>
      {props.children}
    </div>
  );
};

export const SuccessModalHelpers: React.FC<ISuccessModalProps> = (props) => {
  return (
    <Modal
      className={modalContainer}
      show={props.show}
      onHide={props.onHide}
      size={props.modalSize}
      aria-label="Success"
    >
      <Modal.Header className={modalHeader} closeButton />
      <Modal.Body className={modalBody}>{props.children}</Modal.Body>
    </Modal>
  );
};

export default SuccessModalHelpers;
